import { LIST_ROW_ACTIONS_CLASS } from '@/modules/base/components/list/constants'

interface ShouldSkipRowClickParams {
  target?: Element | null
}

/**
 * Decides whether a row click must not be forwarded to the consumer of the list.
 *
 * Extracted from the list component so the guards stay unit testable: AG Grid attaches its
 * native click listener to the row element, so it runs before any synthetic React handler higher up.
 * A `stopPropagation()` inside a cell renderer is therefore too late and these guards are the
 * only thing preventing an unwanted row activation.
 *
 * The expand chevron needs no guard of its own, AG Grid marks its own click as handled.
 */
const shouldSkipRowClick = ({ target }: ShouldSkipRowClickParams): boolean => {
  // The checkbox column toggles the row selection instead of activating the row.
  if (target?.closest?.('[col-id="select"]')) {
    return true
  }

  // The buttons of a row actions cell act on the row instead of activating it.
  if (target?.closest?.(`.${LIST_ROW_ACTIONS_CLASS}`)) {
    return true
  }

  return false
}

export default shouldSkipRowClick
